import { SerializedStyles, css } from "@emotion/react";
import styled from "@emotion/styled";

import { DesignToken, SpacingToken } from "@livechat/design-system-react-components";

import { BackButton, CloseButton } from "components/grid";
import { Icon } from "components/icon";
import { ResponsiveBreakpoint, ResponsiveBreakpointType } from "constants/responsive-breakpoint";
import { ISelectedWidget } from "interfaces/customerDetailsWidgetInterface";
import { withVar } from "themes/helpers";

export const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1 0 auto;
  font-size: 14px;
  width: 100%;
  height: 100%;
  background-color: ${withVar(DesignToken.SurfacePrimaryDefault)};
`;

export const StyledBackButton = styled(BackButton)`
  display: flex;

  @media (min-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    display: none;
  }
`;

export const StyledCloseButton = styled(CloseButton)`
  display: none;

  @media (min-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    display: flex;
  }
`;

export const StyledTitle = styled.div`
  @media (max-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    margin-left: 30px;
  }
`;

export const TicketsDetailsContainer = styled.div`
  box-sizing: border-box;
  padding: 0;
  padding-bottom: ${withVar(SpacingToken.Spacing8)};
  height: 100%;
  overflow: auto;
  display: flex;
  align-items: flex-start;
`;

export const TicketsDetailsContent = styled.div<{ widgets: ISelectedWidget[] }>`
  width: 100%;
  padding-bottom: 40px;
  @media (min-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    display: flex;
    flex-direction: column;

    ${(p): SerializedStyles =>
      p.widgets.length > 0
        ? css`
            width: calc(100% - 48px);
          `
        : css`
            width: 100%;
          `}
  }
`;

export const TicketsDetailsWidgetsContainer = styled.div`
  display: none;

  @media (min-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    position: sticky;
    top: 0;
    display: flex;
    flex-direction: column;
    align-items: center;
    height: 100%;
    width: 48px;
    border-left: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
  }
`;

export const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  margin-left: 30px;
`;

export const IconWrapper = styled.span`
  display: flex;
  margin-right: 8px;
`;

export const WidgetIcon = styled.img`
  width: 24px;
  height: 24px;
  border-radius: 4px;
`;

export const WidgetName = styled.div`
  display: flex;
  font-size: 16px;
  font-weight: 600;
`;

export const SectionWrapper = styled.div<{ borderTop?: boolean }>`
  ${(p): SerializedStyles =>
    p.borderTop
      ? css`
          border-top: 1px solid ${withVar(DesignToken.BorderBasicSecondary)};
        `
      : css``}

  > div {
    border: none;
    margin: 0px;
    > div {
      font-size: 16px;
    }
  }
`;

export const SourceWrapper = styled.div`
  a {
    color: ${withVar(DesignToken.ActionPrimaryDefault)};
    text-decoration: none;

    &:hover {
      text-decoration: underline;
    }
  }
`;

export const StyledLabelWithTooltip = styled.div`
  display: inline-flex;
  align-items: center;
  gap: var(${SpacingToken.Spacing1});

  @media (max-width: ${ResponsiveBreakpoint[ResponsiveBreakpointType.Mobile]}px) {
    .tooltip {
      display: none;
    }
  }
`;

export const StyledIcon = styled(Icon)`
  margin-left: 4px;
`;

export const AddApplicationLink = styled.button<{ disabled: boolean }>`
  border: none;
  background: none;
  padding: 0;
  margin: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 12px 0;
  ${(p): SerializedStyles =>
    p.disabled
      ? css`
          opacity: 0.6;
          pointer-events: none;
        `
      : css``}
`;

export const addApplicationIconStyles = css`
  svg {
    width: 24px;
    height: 24px;
    color: var(${DesignToken.ContentBasicPrimary});
  }
`;

export const StyledLine = styled.div`
  height: 1px;
  background-color: var(${DesignToken.BorderBasicTertiary});
  width: calc(100% - 24px);
  margin: 0px 12px;
`;
